import { deleteDoc, doc } from 'firebase/firestore';
import Failure from '../../../core/Failure';

import { FirestoreCollections, firestore } from '../../../firebase.config';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import Domain from '../../models/Domain';

async function deleteDomain(
  domain: Domain,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new DeleteDomainFailure('Unauthorized', 'unauthorized');
  }
  try {
    const numberId = domain.id;
    await deleteDoc(doc(firestore, FirestoreCollections.domains, numberId));
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new DeleteDomainFailure();
  }
}

export class DeleteDomainFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteDomain;
